export default __webpack_public_path__ + "static/media/portl-logo-white.b0c06213.png";